export function Secao({ titulo, descricao, acao, children }) {
  return (
    <section>
      <div className="mb-6 flex items-end justify-between gap-4">
        <div>
          <h2 className="font-display text-ink text-2xl">{titulo}</h2>
          {descricao && (
            <p className="text-ink-soft/70 mt-1 text-sm">{descricao}</p>
          )}
        </div>
        {acao}
      </div>
      {children}
    </section>
  );
}

export function Cartao({ children, className = '' }) {
  return (
    <div
      className={`border-petal rounded-2xl border bg-white p-5 ${className}`}
    >
      {children}
    </div>
  );
}

export function Carregando({ linhas = 3 }) {
  return (
    <div className="space-y-3" aria-busy="true" aria-live="polite">
      {Array.from({ length: linhas }).map((_, i) => (
        <div key={i} className="border-petal rounded-2xl border bg-white p-5">
          <div className="bg-linen h-4 w-1/3 animate-pulse rounded" />
          <div className="bg-linen mt-3 h-3 w-2/3 animate-pulse rounded" />
        </div>
      ))}
    </div>
  );
}

export function EstadoVazio({ titulo, descricao, acao }) {
  return (
    <div className="border-petal rounded-2xl border border-dashed bg-white/60 px-6 py-12 text-center">
      <span className="text-wine/40 text-2xl">✦</span>
      <p className="text-ink mt-3 font-medium">{titulo}</p>
      {descricao && (
        <p className="text-ink-soft/70 mx-auto mt-1 max-w-sm text-sm">
          {descricao}
        </p>
      )}
      {acao && <div className="mt-5">{acao}</div>}
    </div>
  );
}

export function ErroCarregamento({ onTentarNovamente }) {
  return (
    <div className="border-outline bg-blush-light rounded-2xl border px-6 py-8 text-center">
      <p className="text-ink text-sm font-medium">
        Não conseguimos carregar estas informações.
      </p>
      <button
        type="button"
        onClick={onTentarNovamente}
        className="text-wine hover:text-wine-deep mt-3 text-sm font-semibold underline-offset-4 hover:underline"
      >
        Tentar novamente
      </button>
    </div>
  );
}

const ESTILOS_STATUS = {
  CONFIRMED: 'bg-petal text-ink-soft',
  ACTIVE: 'bg-petal text-ink-soft',
  PAID: 'bg-petal text-ink-soft',
  PENDING: 'bg-paper-warm text-graphite',
  OVERDUE: 'bg-blush text-accent',
  CANCELLED: 'bg-linen text-graphite',
  EXPIRED: 'bg-linen text-graphite',
};

const ROTULOS_STATUS = {
  CONFIRMED: 'Confirmada',
  ACTIVE: 'Ativa',
  PAID: 'Pago',
  PENDING: 'Pendente',
  OVERDUE: 'Em atraso',
  CANCELLED: 'Cancelada',
  EXPIRED: 'Expirada',
};

export function Status({ valor }) {
  if (!valor) return null;
  return (
    <span
      className={`inline-flex shrink-0 rounded-full px-3 py-1 text-xs font-semibold ${
        ESTILOS_STATUS[valor] ?? 'bg-paper-warm text-graphite'
      }`}
    >
      {ROTULOS_STATUS[valor] ?? valor}
    </span>
  );
}
